import { render, staticRenderFns } from "./FR.vue?vue&type=template&id=50de2255&scoped=true&"
import script from "./FR.vue?vue&type=script&lang=js&"
export * from "./FR.vue?vue&type=script&lang=js&"
import style0 from "./FR.vue?vue&type=style&index=0&id=50de2255&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de2255",
  null
  
)

export default component.exports